import { observer } from 'mobx-react-lite'
import { JobCreationBillingContainer } from '@/features/jobs/drafting/components/CreateJobDialog/JobCreationBilling/JobCreationBillingContainer'
import { OCRConfirmSubmitDialog } from '@/features/jobs/scoping/components/OCRConfirmSubmitDialog'
import { type OCRConfirmSubmitDialogViewModel } from './OCRConfirmSubmitDialogViewModel'

export interface OCRConfirmSubmitDialogContainerProps {
  vm: OCRConfirmSubmitDialogViewModel
}

export const OCRConfirmSubmitDialogContainer = observer(
  function OCRConfirmSubmitDialogContainer({
    vm,
  }: OCRConfirmSubmitDialogContainerProps) {
    return (
      <OCRConfirmSubmitDialog
        showing={vm.modal.showing}
        isBillingRelevant={vm.isBillingRelevant}
        billing={
          vm.isBillingRelevant && <JobCreationBillingContainer vm={vm.editor} />
        }
        isSubmitPending={vm.submit.pending}
        onClose={vm.cancel}
        onConfirm={vm.submit}
      />
    )
  },
)
